import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "chat box" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = {
  key: 2,
  class: "message-attach__list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "message-attach__file"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 2,
  class: "message-attach__overlay"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "message-attach__icon-download" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "message-help" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_18 = { class: "message-input mb-3" }
const _hoisted_19 = { class: "is-pulled-right" }
const _hoisted_20 = { class: "button is-link mr-3 is-light" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-greater-than" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "Отправить", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "p-2" }
const _hoisted_26 = {
  key: 0,
  class: "is-inline"
}
const _hoisted_27 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["mb-3 messages-wrapper with-scrollbar", {'busy': _ctx.ctx.isLoading}]),
      id: "messages-wrapper"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.messages, (message) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["message-block", { 'right': !message.from_agent, 'unread': !message.is_read }]),
          key: message.id
        }, [
          (!message.edit)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "message-text mb-3",
                title: _ctx.decodeHtml(message.text)
              }, _toDisplayString(_ctx.decodeHtml(message.text)), 9, _hoisted_2))
            : _createCommentVNode("", true),
          (message.edit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "input with-scrollbar mb-3",
                  "onUpdate:modelValue": ($event: any) => ((message.text) = $event),
                  style: {"height":"6em"}
                }, null, 8, _hoisted_4), [
                  [_vModelText, message.text]
                ])
              ]))
            : _createCommentVNode("", true),
          (message.attachments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.attachments, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "message-attach__item",
                    key: file.id,
                    onClick: ()=>_ctx.handleAttach(file)
                  }, [
                    (file.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "message-attach__img",
                          src: file.url
                        }, null, 8, _hoisted_7))
                      : (!file.type.match('image'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("a", {
                              class: "message-attach__file_name",
                              title: file.name
                            }, _toDisplayString(file.name), 9, _hoisted_9)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.getName(message)) + ", " + _toDisplayString(_ctx.$filters.dateTimeFromDateString(message.created_at)), 1),
            (message.from_agent === false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (!message.edit)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.editMessage(message))
                      }, " Редактировать", 8, _hoisted_15))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.saveMessage(message))
                      }, " Сохранить", 8, _hoisted_16))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128))
    ], 2),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _withDirectives(_createElementVNode("textarea", {
        class: "input with-scrollbar",
        id: "text-input",
        rows: "3",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
        placeholder: "Напишите сообщение...",
        onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["ctrl"]), ["enter"])),
        onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.read && _ctx.read(...args)))
      }, null, 544), [
        [_vModelText, _ctx.text]
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("span", {
            class: "ml-2",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.attachFile && _ctx.attachFile(...args)))
          }, "Файл")
        ]),
        _createElementVNode("button", {
          class: "button is-link",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
        }, _hoisted_24)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("input", {
          class: "is-hidden file-input",
          type: "file",
          multiple: "true",
          ref: "fileInput",
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
        }, null, 544),
        (_ctx.ctx.attachments.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.attachments, (file, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(file.name), 1),
                    _createElementVNode("span", {
                      onClick: ($event: any) => (_ctx.deleteFile(index)),
                      style: {"cursor":"pointer","color":"red"}
                    }, " X", 8, _hoisted_27)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}